import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";
import { useAuth } from "@/contexts/AuthContext";

export const useWODraws = (workOrderId: string | undefined) => {
  const { user } = useAuth();
  return useQuery({
    queryKey: ["wo_draws", workOrderId],
    queryFn: async () => {
      const { data, error } = await supabase
        .from("wo_draws" as any)
        .select("*")
        .eq("work_order_id", workOrderId!)
        .order("draw_number", { ascending: true });
      if (error) throw error;
      return (data ?? []) as any[];
    },
    enabled: !!user && !!workOrderId,
  });
};

export const useWODrawLines = (drawId: string | undefined) => {
  const { user } = useAuth();
  return useQuery({
    queryKey: ["wo_draw_lines", drawId],
    queryFn: async () => {
      const { data, error } = await supabase
        .from("wo_draw_lines" as any)
        .select("*")
        .eq("draw_id", drawId!);
      if (error) throw error;
      return (data ?? []) as any[];
    },
    enabled: !!user && !!drawId,
  });
};

export const useNextDrawNumber = (workOrderId: string | undefined) => {
  const { data: draws } = useWODraws(workOrderId);
  const maxDraw = (draws ?? []).reduce((m: number, d: any) => Math.max(m, d.draw_number), 0);
  return maxDraw + 1;
};
